import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-not-found-error',
  templateUrl: './not-found-error.component.html',
  styleUrls: ['./not-found-error.component.scss'],
})
export class NotFoundErrorComponent {}
